"use strict";

export var FormType = /* @__PURE__ */function (FormType2) {
  FormType2["Text"] = "text";
  FormType2["Dropdown"] = "dropdown";
  FormType2["Radio"] = "radio";
  FormType2["OptionGroup"] = "optionGroup";
  return FormType2;
}(FormType || {});
export var FormWidth = /* @__PURE__ */function (FormWidth2) {
  FormWidth2["Normal"] = "normal";
  FormWidth2["Wide"] = "wide";
  return FormWidth2;
}(FormWidth || {});
export var FormInputSize = /* @__PURE__ */function (FormInputSize2) {
  FormInputSize2["Small"] = "small";
  FormInputSize2["Medium"] = "medium";
  FormInputSize2["Large"] = "large";
  return FormInputSize2;
}(FormInputSize || {});